import { render, staticRenderFns } from "./updataList.vue?vue&type=template&id=0e65fbb0&scoped=true&"
import script from "./updataList.vue?vue&type=script&lang=js&"
export * from "./updataList.vue?vue&type=script&lang=js&"
import style0 from "./updataList.vue?vue&type=style&index=0&id=0e65fbb0&lang=scss&scoped=true&"
import style1 from "./updataList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e65fbb0",
  null
  
)

export default component.exports